"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _tracker = require("ui-addon-upgrades/_core/common/eventTracking/tracker");

var _AuthAdminSelectors = require("pricing-pages-unified-ui/selectors/AuthAdminSelectors");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _reactRouterDom = require("react-router-dom");

var _hubspotPluginCommon = require("hubspot-plugin-common");

var _useUpgradeSourceFromLocation = _interopRequireDefault(require("pricing-pages-unified-ui/utils/useUpgradeSourceFromLocation"));

var PublicApplicationComponents = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "PublicApplicationComponents" */
    'pricing-pages-unified-ui/containers/PublicApplicationComponents');
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});

var isHubSpotDotComAuthedUserRedirect = function isHubSpotDotComAuthedUserRedirect() {
  // Has to work for different TLDs, e.g. www.hubspot.jp
  var WWW_REFERRER_SUBSTRING = 'www.hubspot.';
  var BR_REFERRER_SUBSTRING = 'br.hubspot.'; // If you have multiple portals, you go from public pricing -> portal picker page -> in-app page. This is not perfect detection
  // as it will pick up ANY time you short link to pricing, regardless
  // of origin, but this is likely CloseEnough.

  var PORTAL_PICKER_REFERRER_SUBSTRING = 'https://app.hubspot.com/portal-recommend/l?slug=pricing';
  var QA_TEST_REFERRER_SUBSTRING = '/public-pricing';
  var _document = document,
      referrer = _document.referrer;
  return Boolean(referrer.indexOf(WWW_REFERRER_SUBSTRING) > -1 || referrer.indexOf(BR_REFERRER_SUBSTRING) > -1 || referrer.indexOf(QA_TEST_REFERRER_SUBSTRING) > -1 || referrer.indexOf(PORTAL_PICKER_REFERRER_SUBSTRING) > -1);
};

var Application = function Application(_ref) {
  var children = _ref.children,
      isAppAuth = _ref.isAppAuth,
      isBillingAdmin = _ref.isBillingAdmin,
      location = _ref.location;
  var upgradeSource = (0, _useUpgradeSourceFromLocation.default)();
  (0, _react.useEffect)(function () {
    var wpParams = {
      'wordpress-plugin': _hubspotPluginCommon.isWordPress
    };
    (0, _getUsageTracker.default)().setProperties(Object.assign({
      isBillingAdmin: isBillingAdmin,
      upgradeSource: upgradeSource,
      inAppOrPublic: isAppAuth ? 'in-app' : 'public',
      isDotComAuthedRedirect: isAppAuth && isHubSpotDotComAuthedUserRedirect()
    }, wpParams)); //Set the properties for the "upgrade" app too

    _tracker.tracker.setProperties(Object.assign({}, wpParams));
  }, []);

  if (isAppAuth) {
    if (isHubSpotDotComAuthedUserRedirect()) {
      // If we came from public hubspot.com/pricing render the dot com marketing nav.
      // This represents authenticated users who go to the website pricing pages
      // We want to preserve the dot com nav since otherwise it would lead to a weird
      // experience where they'd lose their nav and couldnt go back without using the
      // browser back button
      return _react.default.createElement(PublicApplicationComponents, {
        isLoggedIn: true,
        pathname: location.pathname
      }, _react.default.createElement("div", {
        className: "app-auth-marketing-nav-wrapped-page"
      }, children));
    } else {
      return _react.default.createElement("div", null, children);
    }
  } else {
    return _react.default.createElement(PublicApplicationComponents, {
      isLoggedIn: false,
      pathname: location.pathname
    }, children);
  }
};

Application.propTypes = {
  children: _propTypes.default.node.isRequired,
  isBillingAdmin: _propTypes.default.bool.isRequired,
  location: _propTypes.default.shape({
    query: _propTypes.default.object
  }),
  isAppAuth: _propTypes.default.bool.isRequired
};

function mapStateToProps(state) {
  return {
    isBillingAdmin: (0, _AuthAdminSelectors.isBillingAdminSelector)(state),
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
}

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Application));

exports.default = _default;
module.exports = exports.default;